import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet, apiPost } from "../../lib/axiosInstance";

export const fetchSettings = createAsyncThunk(
	"common/fetchSettings",
	async (_, { rejectWithValue }) => {
		try {
			const data = await apiGet("/seo");
			return data.settings;
		} catch (err) {
			return rejectWithValue(err.message);
		}
	}
);
export const fetchLegalPage = createAsyncThunk(
	"common/fetchLegalPage",
	async (type, { rejectWithValue }) => {
		try {
			const data = await apiGet(`/legal/${type}`);
			return data.page;
		} catch (err) {
			return rejectWithValue(err.message);
		}
	}
);
export const sendContactMessage = createAsyncThunk(
	"common/sendContactMessage",
	async (formData, { rejectWithValue }) => {
		try {
			const data = await apiPost("/contact/submit", formData);
			return data;
		} catch (err) {
			return rejectWithValue(err.message);
		}
	});


const initialState = {
	settings: null,
	legalData:null,
	isLoading: false,
	error: null,
};

const commonSlice = createSlice({
	name: "common",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
		.addCase(fetchSettings.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(fetchSettings.fulfilled, (state, action) => {
			state.isLoading = false;
			state.settings = action.payload;
		})
		.addCase(fetchSettings.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		})
		.addCase(fetchLegalPage.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		})
		.addCase(fetchLegalPage.fulfilled, (state, action) => {
			state.isLoading = false;
			state.legalData = action.payload;
		})
		.addCase(fetchLegalPage.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default commonSlice.reducer;